import { IState } from '../../store';

export function getServiceLiftCounts(state: IState) {
  const {
    offerData: {
      offer: { building },
    },
  } = state;

  return building && building.cargoLiftsCount;
}
